// Local-only config for the StepByStepV2 scheduler wizard.
//
// Reference/option lists that map to Salesforce-synced enums now live in the
// Vuex store as getters (single source of truth), so they stay in step with the
// rest of the app and the backend:
//   PARTS         -> getter `medicareParts`
//   COVERAGE      -> getter `coverageUrgencies`
//   EMPLOYER_REL  -> getter `groupRelationships`
//   GUEST_REL     -> getter `clientRelationships`
//   GENDERS       -> getter `genders`
//   CONNECTIONS   -> getter `connections`
//   SOA_PRODUCTS  -> getter `soaProducts`
//   MONTHS        -> getter `months`
//   DOW_SHORT     -> getter `dowShort`
//   DOW_FULL      -> getter `dowFull`
//   (US states)   -> getter `usStates`
//
// What stays here is wizard-only UI config with no Salesforce/enum coupling.

// Maps to boolean flags on User: hsa, collecting_ssi, moving. These are plain
// booleans (not a Salesforce enum), so they stay local to the wizard.
export const SC_OPTIONS = [
    {
        id: 'hsa',
        t: 'I or my company contribute to a Health Savings Account (HSA)',
        d: "We'll explain how Medicare enrollment affects HSA contributions.",
        info: 'A health savings account, or HSA, is a type of savings account that lets you set aside money on a pre-tax basis to pay for qualified medical expenses.',
    },
    {
        id: 'collecting_ssi',
        t: "I'm collecting Social Security or Railroad Retirement",
        d: 'This may auto-enroll you in Medicare Part A.',
    },
    {
        id: 'moving',
        t: 'I plan on moving to a different state within the next 12 months',
        d: "Plan availability varies by location — we'll factor in where you're headed.",
    },
]

// Wizard step labels (UI chrome only).
export const STEPS = [
    { id: 'eligibility', label: 'Start' },
    { id: 'about', label: 'About you' },
    { id: 'schedule', label: 'Time' },
    { id: 'guests', label: 'Guests' },
    { id: 'soa', label: 'Sign' },
]

export const HOLD_TTL_MS = 15 * 60 * 1000 // mirrors backend DEFAULT_HOLD_TTL

export function buildSessionId () {
    // Per-attempt UUID. Persisted by StepByStepV2 in sessionStorage so the
    // hold key survives a refresh in the same tab; a new tab is a new attempt.
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID()
    }
    return 'sv2-' + Math.random().toString(36).slice(2) + Date.now().toString(36)
}
